// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4298":"d5b6a876","5538":"cf1a7cba","5942":"d5b6a876","6749":"5c745074"}[chunkId] + ".chunk.css";
};